import type { Dispatch, SetStateAction } from "react";
import { Form } from "react-bootstrap";
import { ChevronDown } from "react-bootstrap-icons";
import { Popover, PopoverContent, PopoverTrigger } from "@/utils/popover";
import type { DropDownItem } from "./DropDownFilterList";

interface Props {
  id?: string;
  text?: string;
  itemsList?: DropDownItem[];
  activeFilter: string | null;
  updateFilter: Dispatch<SetStateAction<string | null>>;
}

export function DropDownRadio(props: Props) {
  return (
    <Popover placement="bottom-start" modal={true}>
      <PopoverTrigger
        style={{
          border: "none",
          background: "none",
          padding: 0,
          paddingRight: "8px",
        }}
      >
        <div
          className="btn btn-outline-primary btn-sm popper-btn-custom"
          style={{ maxHeight: "26px", fontSize: "12px" }}
        >
          {props.activeFilter === null ? props.text : props.activeFilter}
          <ChevronDown />
        </div>
      </PopoverTrigger>
      <PopoverContent>
        <div className="popper-filter-dropdown" id={props.id}>
          <ul className="list-unstyled">
            {props.itemsList?.map((item) => (
              <li key={item?.id ? item.name : Math.random()}>
                <Form.Check
                  type="radio"
                  id={`radio-${item.id}`}
                  checked={props.activeFilter === item.id}
                  onChange={() => props.updateFilter(item.id)}
                  label={item?.name}
                />
              </li>
            ))}
          </ul>
        </div>
      </PopoverContent>
    </Popover>
  );
}
